/* eslint-disable indent */
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { NextSeo } from 'next-seo';
import { API_URI, APP_IMG } from 'src/constants';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { useRouter } from 'next/router';
// import Layout from 'src/components/layouts';
import { NextPage } from 'next';
const Layout = dynamic(import('src/components/layouts'));
const CardV = dynamic(import('src/components/cards/card-v'));
const ContentLoader = dynamic(import('src/components/content-loader'));

const mockArray = [{ id: '1' }, { id: '2' }, { id: '3' }, { id: '4' }, { id: '5' }, { id: '6' }];

type Props = {
  sessionSevId?: any;
  navBar?: any;
};

const PageError: NextPage<Props> = ({ navBar, sessionSevId }: any | Props) => {
  const router = useRouter();

  const [dataLatestNews, setDataLatestNews]: any = useState(null);
  const [navbarDataFetch, setNavbarDataFetch]: any = useState(null);

  useEffect(() => {
    const error = async () => {
      const res = await fetch(`${API_URI}/api/v1.0/categories/latest-news-by-one`);
      const resJson = await res.json();
      if ('msg' in resJson) {
        await setDataLatestNews(null);
      } else {
        await setDataLatestNews(resJson);
      }

      const resData = await fetch(`${API_URI}/api/v1.0/navigations/menu-nav?limit=6`);
      const resJsonData = await resData.json();
      if ('msg' in resJsonData) {
        await setNavbarDataFetch(null);
      } else {
        await setNavbarDataFetch(resJsonData);
      }
    };

    error();
  }, []);

  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo noindex={true} nofollow={true} />
      <Layout sessionSevId={sessionSevId} data={{ header: navBar || navbarDataFetch, footer: navBar || navbarDataFetch }}>
        <PageErrorWrapper className='page-404'>
          <section className='container'>
            <div className='error-box text-center'>
              <img src={`${APP_IMG}/images/logo.png`} loading='lazy' alt='no-article' title='no-article' width='100%' />
              <div className='mt-15'>
                <a href='/' className='btn-error' aria-label='Error' title='error'>
                  กลับสู่หน้าหลัก
                </a>
              </div>
            </div>
            <div className='row error-news'>
              {dataLatestNews !== null
                ? dataLatestNews?.data?.slice(0, 6).map((item: any, i: number) => (
                    <div key={i} className='col-6 col-md-4 mt-30'>
                      <CardV
                        data={item}
                        showByline={false}
                        showTitle={true}
                        showBlurb={true}
                        showTime={false}
                        showCountview={false}
                        external={false}
                        className=''
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_INDEX,
                          router: router?.pathname,
                          section: 'section-1',
                          data: {
                            title: item?.title,
                            heading: 'ข่าวล่าสุด',
                            index: i + 1
                          }
                        }}
                      />
                    </div>
                  ))
                : mockArray.map(item => (
                    <div key={item.id} className='col-6 col-md-4'>
                      <ContentLoader />
                    </div>
                  ))}
            </div>
          </section>
        </PageErrorWrapper>
      </Layout>
    </>
  );
};

const PageErrorWrapper = styled.div`
  padding: 30px 0;

  .text-center {
    text-align: center;
  }
  .btn-error {
    font-size: 24px;
    border-bottom: 2px solid;
    &:hover {
      border-bottom: 2px solid #ef394f;
    }
  }

  .error-box {
    margin: auto;
    width: 100%;
    max-width: 300px;
    height: 400px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    img {
      opacity: 0.5;
    }
  }
  .no-article {
    width: auto;
    margin: 100px auto;
    opacity: 0.3;
    -webkit-filter: grayscale(40%);
    filter: grayscale(40%);
    @media (max-width: 475px) {
      margin: 38px auto;
    }
  }
`;

export default PageError;
